import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, LayoutGrid, Blocks } from 'lucide-react';
import { v4 } from 'uuid';
import { useAlertContext } from '../contexts/Alert';
import { USER_URL } from '../api_base.js';
import { buildHeaders } from '../utils/apiHeaders.js';
import { checkMaintenance } from '../utils/checkMaintenance.js';

const Apps = () => {
    const [apps, setApps] = useState([]);
    const [loading, setLoading] = useState(true);

    const { setAlerts } = useAlertContext();
    const navigate = useNavigate();

    const pushAlert = (text) => setAlerts(prev => ([...prev, { id: v4(), text }]));

    useEffect(() => {
        const fetchApps = async () => {
            try {
                const res = await fetch(USER_URL + "/apps", {
                    method: "GET",
                    credentials: "include",
                    headers: buildHeaders(),
                });
                const data = await res.json();

                if (!res.ok || data.failed) {
                    if (data.signout) navigate("/auth");
                    pushAlert(data.message || "Oops! something went wrong while loading your apps.");
                    return;
                }

                setApps(data.data || []);
                checkMaintenance(data , navigate);
            } catch (err) {
                pushAlert("Oops! something went wrong while reaching the server.");
            } finally {
                setLoading(false);
            }
        }
        fetchApps();
    }, []);

    return (
        <div className="page">
            <div className="page_header">
                <button className="back" onClick={() => navigate("/")}><ChevronLeft /></button>
                <div className="page_title">
                    <h2>Your Apps</h2>
                    <p>Every app linked to your account.</p>
                </div>
            </div>

            <div className="page_body">
                {loading ? (
                    <div className="empty_state"><span className="loading"></span></div>
                ) : apps.length === 0 ? (
                    <div className="empty_state">
                        <Blocks size="40" />
                        <h3>No apps yet</h3>
                        <p>Apps you sign into will show up here.</p>
                    </div>
                ) : (
                    <div className="apps_grid">
                        {apps.map(app => (
                            <button className="app_card" key={app.appId} onClick={() => navigate(`/apps/${app.appId}`)}>
                                {app.inMaintenance ? <span className="maintenance_badge">Maintenance</span> : null}
                                {app.appIcon ? <img src={app.appIcon} alt={app.appName} /> : (
                                    <div className="nav_card_icon"><LayoutGrid size="20" /></div>
                                )}
                                <h3>{app.appName}</h3>
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </div>
    )
}

export default Apps;
